module.exports = __webpack_public_path__ + "static/img/home_buffer_photo5.34b22b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/home_buffer_photo5.png
// module id = nsMb
// module chunks = 0